import { useState } from "react";
import { Flower2, ChevronLeft, ChevronRight } from "lucide-react";
import { shlokas } from "../../mock/mock";

const Shlokas = () => {
  const [idx, setIdx] = useState(0);
  const shloka = shlokas[idx];

  return (
    <section className="py-20 bg-gradient-to-br from-orange-900 via-red-900 to-amber-900 text-white relative overflow-hidden">
      {/* Decorative mandala pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 border-4 border-yellow-300 rounded-full" />
        <div className="absolute top-20 left-20 w-44 h-44 border-4 border-yellow-300 rounded-full" />
        <div className="absolute bottom-10 right-10 w-80 h-80 border-4 border-yellow-300 rounded-full" />
        <div className="absolute bottom-20 right-20 w-60 h-60 border-4 border-yellow-300 rounded-full" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-yellow-300/30 mb-4">
            <Flower2 className="w-4 h-4 text-yellow-300" />
            <span className="text-xs font-semibold text-yellow-200 tracking-widest uppercase">Sanskrit Shlokas</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Voices of <span className="text-yellow-300">Ancient Wisdom</span>
          </h2>
          <p className="text-orange-100">
            Simple, powerful shlokas that our little learners recite every day — rooting them in Sanatan values while building memory, pronunciation and confidence.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-md rounded-3xl border border-yellow-300/20 p-8 md:p-12 shadow-2xl">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-xs uppercase tracking-widest text-yellow-300/70">Shloka {idx + 1} of {shlokas.length}</p>
                <h3 className="font-display text-2xl md:text-3xl font-bold text-yellow-200 mt-1">{shloka.title}</h3>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setIdx((idx - 1 + shlokas.length) % shlokas.length)}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-yellow-300/20 flex items-center justify-center transition-colors"
                  aria-label="Previous"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setIdx((idx + 1) % shlokas.length)}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-yellow-300/20 flex items-center justify-center transition-colors"
                  aria-label="Next"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>

            <div className="py-6 border-y border-yellow-300/20">
              <p className="font-devanagari text-2xl md:text-3xl leading-relaxed text-yellow-100 whitespace-pre-line text-center">
                {shloka.devanagari}
              </p>
            </div>

            <div className="mt-6 space-y-4">
              <div>
                <p className="text-xs uppercase tracking-widest text-yellow-300/70 mb-1">Transliteration</p>
                <p className="italic text-orange-100 leading-relaxed whitespace-pre-line">{shloka.transliteration}</p>
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-yellow-300/70 mb-1">Meaning</p>
                <p className="text-white/90 leading-relaxed">{shloka.meaning}</p>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-6">
            {shlokas.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-yellow-300" : "w-3 bg-white/30"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shlokas;
